module.exports = __webpack_public_path__ + "static/media/kak2c_logo_english.cbedb8fe.svg";